// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1rMOT","col":"CardReaderDesc_col__wytW_","label":"CardReaderDesc_label__16J1p"};